import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "@/i18n/translations";

const LangCtx = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("obra_lang") || "en");

  useEffect(() => {
    localStorage.setItem("obra_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key, vars) => {
    const dict = translations[lang] || translations.en;
    let str = dict[key] ?? translations.en[key] ?? key;
    if (vars) {
      for (const [k, v] of Object.entries(vars)) {
        str = str.replace(new RegExp(`{${k}}`, "g"), String(v));
      }
    }
    return str;
  };

  return (
    <LangCtx.Provider value={{ lang, setLang, t }}>
      {children}
    </LangCtx.Provider>
  );
}

export const useLang = () => useContext(LangCtx);
